export default __webpack_public_path__ + "2443f6c7cb3f3d67614efceb99d10718.svg";